import Http from '@/api/http.js'
import Reversal from './financials/reversal'
import Bill from './financials/bill'



export default {
  ...Bill,
  ...Reversal,

  index(kind, filter){
    return Http.get(`/${kind}`,{
      headers: {
        filter: JSON.stringify(filter)
      }
    });
  },
  create(kind, newFinancial){
    if (kind == 'vrt_transactions'){
      return Http.post(`/${kind}`, {
        vrt_transaction: {
          transaction_type_id:  null, //newFinancial.transaction_type,
          origin_id:            null, //newFinancial.origin_id,
          destination_id:       null, //newFinancial.destination_id,
          status_id:            null, //newFinancial.status_id,
          
          ammount:              newFinancial.ammount,
          value_payed:          newFinancial.value_payed,
          DateExpired:          newFinancial.DateExpired,
          comment:              newFinancial.comment,
          bank_account_id:      newFinancial.bank_account_id,
        }
      })
    }
  },
  update(kind, financial, id, next_actions) {
    if (kind == 'vrt_transactions'){
      return Http.put(`/${kind}/${id}`, {
        vrt_transaction: {
          id:                   id, 
          ammount:              financial.attributes.ammount,
          transaction_type_id:  financial.attributes.transaction_type_id,
          DateExpired:          financial.attributes.DateExpired,
          origin_id:            financial.attributes.origin_id,
          destination_id:       financial.attributes.destination_id,
          comment:              financial.attributes.comment,
          bank_account_id:      financial.attributes.bank_account_id,
          
          order_id:             financial.attributes.order_id,

          date_payed_doc:       financial.attributes.date_payed_doc,
          value_payed:          financial.attributes.value_payed,
          status:               financial.attributes.status, //string , shuld be payed
          'document_attributes':   financial.attributes.attachment_attributes,
          // payment_option_id:   financial.attributes.payment_option_id,
        }},
        {
          headers: {
            NextActions: JSON.stringify(next_actions)
          }
        })
    }
  },
  updateManyTransactions(financials) {    
    return Http.put(`/vrt_transactions/update_bulk/`, {
      vrt_transactions: {
        ids:                  financials, 
        // NAO USAREI ammount:              financials.attributes.ammount,
        // NAO USAREI comment:              financials.attributes.comment,
        // date_payed_doc:       financials.attributes.date_payed_doc, //talvez pegar no back a data de hoje ficaria mais facil.
        // value_payed:          financials.attributes.value_payed, // fazer o ammount no back
        // status_id:            financials.attributes.status_id, //talvez pegar no back é mais facil.
      }
    })
  },

  

  // PAYMENTS
    clientPayments(client_id, is_historic, start_date, end_date){
      return Http.get(`/payments.json`,{
        params:{
          client_id,
          is_historic,
          start_date,
          end_date
        },
        headers: {
          // filter: JSON.stringify(filter)
        }
      });
    },
    clientPaymentsPdf(client_id, is_historic, start_date, end_date){
      return Http.get(`/payments.pdf`,{
        params:{
          client_id,
          is_historic,
          start_date,
          end_date
        },
        headers: {
          // filter: JSON.stringify(filter)
        }
      });
    },
    indexPayment(){
      return Http.get(`/payments`,{
        headers: {
          // filter: JSON.stringify(filter)
        }
      });
    },
    deletePayment(id){
      return Http.delete(`/payments/${id}`);
    },
    createPayment(newPayment){
      return Http.post(`/payments`,{
        payment:{
          client_id:   newPayment.client_id,
          kind:        newPayment.kind,
          total_value: newPayment.total_value,
          payed_at:    newPayment.payed_at,
          status_id:   newPayment.status_id,
          cash_value:  newPayment.cash_value,
          check_value: newPayment.check_value,

          exclusive_envelope: newPayment.exclusive_envelope,
          
          // envelope_id: newPayment.envelope_id,
          'cash_attributes': newPayment.cash_attributes ,
          'checks_attributes': newPayment.checks_attributes ,
          'deposit_attributes': newPayment.deposit_attributes ,
        }
      })

    },
    updatePayment(upPayment){
      return Http.put(`/payments/${upPayment.id}`,{
        payment:{
          id:          upPayment.id,
          client_id:   upPayment.client_id,
          kind:        upPayment.kind,
          total_value: upPayment.total_value,
          payed_at:    upPayment.payed_at,
          status_id:   upPayment.status_id,
          cash_value:  upPayment.cash_value,
          check_value: upPayment.check_value,
          // envelope_id: newPayment.envelope_id,
          'cash_attributes': upPayment.cash_attributes ,
          'checks_attributes': upPayment.checks_attributes ,
          'deposit_attributes': upPayment.deposit_attributes ,
        }
      })
    },
  //

  // CASH
    
  //

  show(kind, id){
    return Http.get(`/${kind}/${id}`)
  },



  indexCharges(filter){
    return Http.get(`/charges`, {
      params: {
        ...filter
      }
    })
  },


}